export default [
  {
    to: '#inicio',
    label: 'Início',
  },
  {
    to: '#novos-modulos',
    label: 'Novos módulos',
  },
  {
    to: '#o-que-estao-falando',
    label: 'O que estão falando',
  },
  {
    to: '#conheca',
    label: 'Conheça os 3 módulos',
  },
  {
    to: '#ebook',
    label: 'E-book',
  },
  {
    to: '#quero-comprar',
    label: 'Quero comprar',
  },
  {
    to: '#onildo-rocha',
    label: 'Onildo Rocha',
  },
]
